export default {"src":"/_next/static/media/favicon.d5c4877a.ico","height":16,"width":16};